import { render, staticRenderFns } from "./LKProfileAvatar.vue?vue&type=template&id=62dd3002&"
import script from "./LKProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./LKProfileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./LKProfileAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VImg})
